"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _warning = _interopRequireDefault(require("warning"));
var _apollo = require("../apollo");
var _apolloHoc = require("../apollo-hoc");
var _styled = _interopRequireDefault(require("../styled"));
var _InputField = _interopRequireDefault(require("./InputField"));
var _AddressResults = _interopRequireDefault(require("./AddressResults"));
var _templateObject, _templateObject2, _templateObject3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var DEBOUNCE_TIMEOUT = 250;
var searchAddressQuery = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  query SearchAddressQuery($input: SearchAddressInput!) {\n    searchAddress(input: $input) {\n      addresses {\n        id\n        type\n        text\n        highlight\n        description\n      }\n    }\n  }\n"])));
var retrieveAddressQuery = (0, _apollo.gql)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n  query RetrieveAddressQuery($id: String!) {\n    retrieveAddress(id: $id) {\n      id\n      city\n      line1\n      line2\n      line3\n      postalCode\n      countryName\n      label\n    }\n  }\n"])));
var StyledContainer = _styled.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n"])));
var deprecations = function deprecations(props) {
  (0, _warning.default)(props.blurHandler == null, '[AddressLookup] `blurHandler` is deprecated. Use `onBlur` instead.');
};
var AddressLookup = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(AddressLookup, _Component);
  function AddressLookup() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.containerEl = void 0;
    _this.state = {
      value: '',
      selectedItem: {},
      showMenu: false,
      searchResult: {
        loading: false,
        searchAddress: {}
      },
      index: -1
    };
    _this.selectedItemUpdated = function () {
      if (_this.state.selectedItem.type === 'Address') {
        _this.setState({
          value: _this.state.selectedItem.text + " - " + _this.state.selectedItem.description,
          showMenu: false
        });
        _this.props.client.query({
          query: retrieveAddressQuery,
          variables: {
            id: _this.state.selectedItem.id
          }
        }).then(function (data) {
          _this.props.onChange(data.data.retrieveAddress);
        });
        // TODO: error handling
        // .catch(err => {
        // })
      } else {
        _this.props.client.query({
          query: searchAddressQuery,
          variables: {
            input: {
              searchText: _this.state.value,
              refinementId: _this.state.selectedItem.id,
              countries: _this.props.countries,
              limit: _this.props.limit
            }
          }
        }).then(function (data) {
          _this.setState({
            searchResult: {
              searchAddress: data.data.searchAddress,
              loading: data.loading
            }
          });
        });
        // TODO: error handling
        // .catch(err => {
        // })

        _this.setState({
          showMenu: true
        });
      }
    };
    _this.search = (0, _debounce.default)(function (searchValue) {
      if (searchValue !== '') {
        _this.props.client.query({
          query: searchAddressQuery,
          variables: {
            input: {
              searchText: searchValue,
              countries: _this.props.countries,
              limit: _this.props.limit
            }
          }
        }).then(function (data) {
          _this.setState({
            searchResult: {
              searchAddress: data.data.searchAddress,
              loading: data.loading
            }
          });
        });
        // TODO: error handling
        // .catch(err => {
        // })
      }
    }, DEBOUNCE_TIMEOUT, {
      leading: true
    });
    _this.handleChange = function (event) {
      var value = event.currentTarget.value;
      _this.setState({
        value: value,
        selectedItem: {},
        showMenu: value !== '',
        searchResult: {
          loading: value !== '',
          searchAddress: {}
        }
      });
      _this.search(value);
    };
    _this.handleSelect = function (item) {
      _this.setState({
        selectedItem: item
      }, function () {
        return _this.selectedItemUpdated();
      });
    };
    _this.handleFocus = function (event) {
      event.target.select();
      document.addEventListener('keydown', _this.onKeyDown);
      document.addEventListener('mousedown', _this.onMouseDown);
    };
    _this.handleBlur = function (event) {
      document.removeEventListener('keydown', _this.onKeyDown);
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      } else if (_this.props.blurHandler) {
        _this.props.blurHandler(event);
      }
    };
    _this.closeMenu = function () {
      _this.setState({
        showMenu: false
      });
      document.removeEventListener('mousedown', _this.onMouseDown);
    };
    _this.selectItem = function (event) {
      event.preventDefault();
      var item = _this.state.searchResult.searchAddress.addresses[_this.state.index];
      if (typeof item !== 'undefined') {
        _this.setState({
          selectedItem: item
        }, function () {
          return _this.selectedItemUpdated();
        });
      }
    };
    _this.onMouseDown = function (event) {
      var activeTarget = event.target || document.activeElement;
      if (!activeTarget || activeTarget instanceof HTMLElement && _this.containerEl != null && !_this.containerEl.contains(activeTarget)) {
        _this.closeMenu();
      }
    };
    _this.selectNext = function () {
      var _this$state = _this.state,
        index = _this$state.index,
        searchResult = _this$state.searchResult;
      if (typeof searchResult.searchAddress !== 'undefined' && typeof searchResult.searchAddress.addresses !== 'undefined') {
        if (index + 1 > searchResult.searchAddress.addresses.length - 1) {
          _this.setState({
            index: 0
          });
        } else {
          _this.setState({
            index: index + 1
          });
        }
      }
    };
    _this.selectPrevious = function () {
      var _this$state2 = _this.state,
        index = _this$state2.index,
        searchResult = _this$state2.searchResult;
      if (typeof searchResult.searchAddress !== 'undefined' && typeof searchResult.searchAddress.addresses !== 'undefined') {
        if (index - 1 < 0) {
          _this.setState({
            index: searchResult.searchAddress.addresses.length - 1
          });
        } else {
          _this.setState({
            index: index - 1
          });
        }
      }
    };
    _this.onKeyDown = function (event) {
      switch (event.key) {
        case 'ArrowDown':
          return _this.selectNext();
        case 'ArrowUp':
          return _this.selectPrevious();
        case 'Enter':
          return _this.selectItem(event);
        case 'Escape':
          return _this.closeMenu();
        default:
          return null;
      }
    };
    return _this;
  }
  var _proto = AddressLookup.prototype;
  _proto.componentWillMount = function componentWillMount() {
    deprecations(this.props);
  };
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    deprecations(nextProps);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('mousedown', this.onMouseDown);
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      label = _this$props.label,
      help = _this$props.help,
      placeholder = _this$props.placeholder;
    var _this$state3 = this.state,
      value = _this$state3.value,
      showMenu = _this$state3.showMenu,
      searchResult = _this$state3.searchResult,
      index = _this$state3.index;
    return /*#__PURE__*/_react.default.createElement(StyledContainer, {
      ref: function ref(node) {
        _this2.containerEl = node;
      }
    }, /*#__PURE__*/_react.default.createElement(_InputField.default, {
      type: "text",
      value: value,
      onChange: this.handleChange,
      label: label,
      explanation: help,
      placeholder: placeholder,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      "data-cs-mask": true
    }), showMenu && /*#__PURE__*/_react.default.createElement(_AddressResults.default, {
      data: searchResult,
      selectedIndex: index,
      onSelect: this.handleSelect
    }));
  };
  return AddressLookup;
}(_react.Component);
AddressLookup.defaultProps = {
  onBlur: null,
  blurHandler: null,
  label: '',
  help: '',
  placeholder: '',
  countries: [],
  limit: 200
};
var AddressLookupWithAppolo = (0, _apolloHoc.withApollo)(AddressLookup);
var _default = exports.default = AddressLookupWithAppolo;